import React from 'react';

import ButtonCloseOverlay from '../ButtonCloseOverlay/index';

import { overlay } from './styles.module.scss';

const VideoOverlay = ({ data, closeOverlay }) => {
  return (
    <div className={overlay}>
      <ButtonCloseOverlay closeOverlay={closeOverlay} />

      {(data?.webinarOnDemandVideoOriginal ||
        data?.webinarOnDemandVideoProgressive) &&
      !data?.webinarOnDemandVideoYoutube ? (
        <video
          autoPlay
          playsInline
          controls
          poster={data.poster}
          width={'100%'}
          height={'100%'}
          disablePictureInPicture
        >
          {data?.webinarOnDemandVideoProgressive ? (
            <source
              src={data?.webinarOnDemandVideoProgressive?.mediaItemUrl}
              type="video/webm"
            />
          ) : (
            <></>
          )}

          <source
            src={data?.webinarOnDemandVideoOriginal?.mediaItemUrl}
            type="video/mp4"
          />
        </video>
      ) : (
        <></>
      )}

      {data?.webinarOnDemandVideoYoutube ? (
        <iframe
          width="100%"
          height="100%"
          src={data?.webinarOnDemandVideoYoutube}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      ) : (
        <></>
      )}
    </div>
  );
};

export default VideoOverlay;
